import { render } from "./vcompany_wxset.vue?vue&type=template&id=4c74e8e0&scoped=true"
import script from "./vcompany_wxset.vue?vue&type=script&lang=js"
export * from "./vcompany_wxset.vue?vue&type=script&lang=js"

import "./vcompany_wxset.vue?vue&type=style&index=0&id=4c74e8e0&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c74e8e0"]])

export default __exports__